import { devtools } from 'zustand/middleware';
import { create } from './advnacedActions';

const initialState = {
  competitions: [],
  competition: {
    details: {
      awardCount: '',
      competitionId: '',
      definitionLink: '',
      description: '',
      end: '',
      name: '',
      registrationEnd: '',
      rulesLink: '',
      start: '',
      status: '',
      thumbnail: null,
      maxSubmissions: null,
    },
    isLoading: true,
    error: null,
  },
  isLoading: true,
  error: null,
};

let competitionStore = (set) => ({
  ...initialState,
  setCompetition: (competition, isLoading, error = null) => {
    set({
      competition: {
        details: competition,
        isLoading,
        error,
      },
    });
  },
  setLoading: (isLoading) => set((state) => ({
    ...state,
    isLoading,
  })),
  setCompetitions: (competitions) => {
    set((state) => ({
      ...state,
      competitions,
      isLoading: false,
    }));
  },
  reset: () => set({ ...initialState }),
});

competitionStore = devtools(competitionStore, { store: 'competitionStore' });

const useCompetitionStore = create(competitionStore);

export default useCompetitionStore;
